<div fxFlexFill fxLayout="row">
  <div class="master-container">
    <router-outlet name="master"></router-outlet>
  </div>
  <div fxFlex>
    <router-outlet name="detail"></router-outlet>
  </div>
</div>
